"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorIcons = exports.getTemplateIcon = void 0;
const react_1 = __importDefault(require("react"));
const template_icons_1 = require("@codesandbox/template-icons");
const icons_1 = __importDefault(require("../templates/icons"));
function getUserIcon(templateName, iconUrl) {
    if (!iconUrl) {
        return undefined;
    }
    if (iconUrl.startsWith('https://')) {
        return ({ width, height }) => (react_1.default.createElement("img", { width: width || 24, height: height || 24, src: iconUrl, alt: templateName }));
    }
    return template_icons_1.ColorIcons[iconUrl];
}
const getTemplateIcon = (templateName, iconUrl, environment) => {
    const UserIcon = getUserIcon(templateName, iconUrl) || (0, icons_1.default)(environment);
    const OfficialIcon = (0, icons_1.default)(environment);
    return {
        UserIcon,
        OfficialIcon,
    };
};
exports.getTemplateIcon = getTemplateIcon;
exports.ColorIcons = template_icons_1.ColorIcons;
